export default __webpack_public_path__ + "static/media/ic_edit_info.65539218.svg";